module.exports = __webpack_public_path__ + "img/aveo_960d_detail.de1ba097.jpg";